"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavState = void 0;
var react_1 = __importDefault(require("react"));
var navState_1 = require("../contexts/navState");
exports.useNavState = function () { return react_1.default.useContext(navState_1.NavStateContext); };
